import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { TransactionsComponent } from './transactions.component';

const routes: Routes = [
  {
    path: '',
    component: TransactionsComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    TransactionsComponent,
  ],
  exports: [TransactionsComponent],
})
export class TransactionsModule {
}
